<template>
  <v-container fluid>
    <template v-if="renderizacaoLiberada">
      <validation-observer ref="observer" v-slot="{ invalid }">
        <v-row justify="center">
          <v-col cols="12">
            <parametros ref="parametrosREF" :item="item" />
          </v-col>
          <v-col cols="12">
            <v-btn
              id="btn-salvar-indice-ipca"
              color="primary"
              min-width="100"
              style="float: right"
              class="mr-0 mt-n5"
              :disabled="invalid"
              :loading="loading"
              @click="salvar()"
            >
              Salvar
            </v-btn>
          </v-col>
        </v-row>
      </validation-observer>
    </template>
    <template v-else>
      <v-container fluid fill-height>
        <v-row align="center" class="mx-auto" style="height: 400px !important">
          <v-col cols="12" align="center" jusitfy="center">
            <v-progress-circular indeterminate color="primary" :size="100" />
          </v-col>
        </v-row>
      </v-container>
    </template>
  </v-container>
</template>
<script>
  import AtualizacaoIndicesService from '@/services/AtualizacaoIndicesService';
  import tourMixins from '@/mixins/tourMixins';

  export default {
    components: {
      Parametros: () => import('@/components/atualizacaoIndices/Parametros.vue')
    },
    mixins: [tourMixins],

    data: () => ({
      item: {},
      loading: false,
      arrTour: [
        {
          element: '#campo-data-referencia-indice-ipca',
          intro: 'Neste campo será possível visualizar o mês de referência do Índice IPCA.',
          scrollTo: 'tooltip',
          position: 'bottom'
        },
        {
          element: '#campo-variacao-ipca',
          intro: 'Neste campo será exibido a variação do índice IPCA referente ao mês anterior.',
          scrollTo: 'tooltip',
          position: 'bottom'
        },
        {
          element: '#campo-indice-ipca',
          intro: 'Neste campo será possivel digitar o índice IPCA.',
          scrollTo: 'tooltip',
          position: 'bottom'
        },
        {
          element: '#btn-salvar-indice-ipca',
          intro: 'Clicando neste botão será possível salvar índice IPCA.',
          scrollTo: 'tooltip',
          position: 'left'
        }
      ]
    }),

    computed: {
      renderizacaoLiberada() {
        if (!this.$route.params.data_registro) return true;

        return this.$route.params.data_registro && JSON.stringify(this.item) !== '{}' ? true : false;
      }
    },

    created() {
      this.$route.params.data_registro ? this.getIndice(this.$route.params.data_registro) : this.iniciarTourPagina();
    },

    methods: {
      getIndice(dataRegistro) {
        AtualizacaoIndicesService.getIndiceByDataRegistro(dataRegistro)
          .then((indice) => {
            this.item = indice.indice_oficial;
            this.iniciarTourPagina();
          })
          .catch(() => this.$toast.error('Erro ao buscar Índice IPCA.', '', { position: 'topRight' }));
      },

      salvar() {
        const data = this.$refs.parametrosREF.exportData();
        this.loading = true;

        AtualizacaoIndicesService.salvar(data)
          .then(() => {
            this.$toast.success('Índice IPCA salvo com sucesso.', '', { position: 'topRight' });
            this.$router.replace({ name: 'Atualização de Índices' });
          })
          .catch((err) => {
            console.error(err);
            this.$toast.error('Erro ao salvar índice IPCA.', '', { position: 'topRight' });
          })
          .finally(() => (this.loading = false));
      },

      iniciarTourPagina() {
        if (this.tourFuncCalled) return;

        this.iniciarTour(this.arrTour);
      }
    }
  };
</script>